export default __webpack_public_path__ + "static/media/movy-es-backend.140d4dbd.png";